import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FiSave, FiX } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { toast } from "react-toastify";
import axiosInstance from "../../axiosInstance";
import * as general from "../../libs/general";

const emptyModel = { id: null, name: "", code: "", description: "" };

const DepartmentEditor = ({
  show,
  onClose,
  onSave,
  onDeleted,
  model,
  canCreate = true,
  canEdit = true,
  canDelete = false,
}) => {
  const [form, setForm] = useState(emptyModel);
  const [nameError, setNameError] = useState("");

  useEffect(() => {
    if (!show) return;
    setForm(model || emptyModel);
    setNameError("");
  }, [show, model]);

  const isNewDepartment = !form?.id;
  const formWritable = isNewDepartment ? canCreate : canEdit;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (name === "name" && nameError) setNameError("");
  };

  const handleSubmit = () => {
    if (!formWritable) return;
    const trimmedName = (form.name || "").trim();
    if (!trimmedName) {
      setNameError("Vui lòng nhập tên phòng ban.");
      return;
    }
    setNameError("");
    onSave({
      ...form,
      name: trimmedName,
      code: (form.code || "").trim(),
      description: (form.description || "").trim(),
    });
  };

  const handleDelete = () => {
    if (!canDelete || !form?.id) return;
    general.openConfirm(async () => {
      try {
        const requestApi = `/api/departments/deleteDepartment?id=${form.id}`;
        const response = await axiosInstance.get(requestApi);
        if (!response.data.success) {
          toast.error(response.data.message);
          return;
        }
        toast.success(response.data.message);
        await onDeleted?.();
        onClose();
      } catch (error) {
        console.error(error);
        toast.error(error.message);
      }
    });
  };

  return (
    <Modal show={show} onHide={onClose} centered dialogClassName="department-modal">
      <Modal.Header closeButton>
        <Modal.Title>{form.id ? "Cập nhật phòng ban" : "Tạo mới phòng ban"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>
            Tên phòng ban <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            name="name"
            readOnly={!formWritable}
            value={form.name}
            onChange={handleChange}
            isInvalid={!!nameError}
          />
          <Form.Control.Feedback type="invalid">{nameError}</Form.Control.Feedback>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <div>
          {form?.id && canDelete && (
            <Button
              size="sm"
              variant="outline-danger"
              className="d-inline-flex align-items-center justify-content-center p-1"
              onClick={handleDelete}
              title="Xóa phòng ban"
            >
              <RiDeleteBin6Line size={16} />
            </Button>
          )}
        </div>
        <div className="d-flex gap-2 ms-auto">
          {formWritable ? (
            <Button
              size="sm"
              variant="primary"
              className="d-inline-flex align-items-center gap-1"
              onClick={handleSubmit}
            >
              <FiSave size={14} />
              Lưu
            </Button>
          ) : (
            <Button
              size="sm"
              variant="secondary"
              className="d-inline-flex align-items-center gap-1"
              onClick={onClose}
            >
              <FiX size={14} />
              Đóng
            </Button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DepartmentEditor;
